import { useCallback, useMemo, useState } from 'react';
import { ApartmentListParams } from '../api/apartments';

export type ApartmentsFilterMode = 'name' | 'address';

export interface ApartmentsFilterState {
  mode: ApartmentsFilterMode;
  query: string;
}

const EMPTY: ApartmentsFilterState = { mode: 'name', query: '' };

export const useApartmentsFilter = () => {
  const [filter, setFilter] = useState<ApartmentsFilterState>(EMPTY);

  const setMode = useCallback((mode: ApartmentsFilterMode) => {
    setFilter({ mode, query: '' });
  }, []);

  const setQuery = useCallback((query: string) => {
    setFilter(prev => ({ ...prev, query }));
  }, []);

  const reset = useCallback(() => setFilter(EMPTY), []);

  const apiParams: Pick<ApartmentListParams, 'name' | 'address'> = useMemo(() => {
    const trimmed = filter.query.trim();
    if (!trimmed) return {};
    return filter.mode === 'name' ? { name: trimmed } : { address: trimmed };
  }, [filter]);

  return { filter, setMode, setQuery, reset, apiParams };
};
